// import CartModalEmpty from "./CartModalEmpty";
import CartModal from "./CartModal";

// import {useContextElement} from "../../context/Context";

const CartComponent = () => {


    // const { pathname } = useLocation();
    // if (pathname === "/cart-empty") return <CartModalEmpty />;
    return <CartModal />;

    //
    // const { cartProducts } = useContextElement();
    //
    // const isEmpty = cartProducts.length === 0;
    //
    // return isEmpty ? <CartModalEmpty /> : <CartModal />;
};

export default CartComponent;
